exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DetailsSection__ads___1ULbp {\n  text-align: center; }\n\n.DetailsSection__adLoaded___2Hc_v {\n  margin-bottom: 14px; }\n", ""]);

// exports
exports.locals = {
	"ads": "DetailsSection__ads___1ULbp",
	"adLoaded": "DetailsSection__adLoaded___2Hc_v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/DetailsSection.scss
// module id = 4388
// module chunks = 6